import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InputField } from "../../components/_input/_input";
import PhoneDropDown from "../../components/_input/_phoneDropDown";
import { TextArea } from "../../components/_input/_textArea";
import { DropDownInput } from "../../components/_input/_dropdown";
import { FormButton } from "../../components/_input/_button";
import CarFeature from "../../components/carFeature";
import Breadcrumb from "../../components/__simple/breadcrumb";
import axios from "axios";
import config from '../../configuration/config';
import Joi from "joi";
import { groupBy, mapValues, omit } from "lodash";
import { GetMessages, formValidate } from '../../utils/validation';
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router";
import { uniqBy } from "lodash";
import { getData, User_Data_Key } from "../../utils/localStorageManager";
import dropDownResetter from "../../utils/resetDropDown";
import Skeleton from 'react-loading-skeleton'
export function CpOrderCarPage() {
    const { t: trans, i18n } = useTranslation(["heading", "finance", "form", "model", "inputs", "info", "eparts"]);
    let lang = (i18n.language || 'ar');
    const [referrer, setReferrer] = useState('');
    const [error, setError] = useState({});
    const [successData, setSuccessData] = useState(false);

    const [product, setproduct] = useState(null);
    const [requestForm, setRequestForm] = useState({
        name: '',
        custType: "G4",
        identityNo: '',
        cn: '',
        address: '',
        email: '',
        phoneNumber: '',
        quantity: 1,
        message: '',
        note: '',
        selectedProduct: '',
        selectedModel: '',
        selectedColor: ''
    });
    const [showProductSection, setShowProductSection] = useState(true);
    const [brands, setBrands] = useState([]);
    const [brand, setBrand] = useState(null);
    const [group, setGroup] = useState(null);
    const [type, setType] = useState(null);
    const [year, setYear] = useState(null);
    const [fColors, setFColors] = useState([]);
    //--------------------------------------------------- 
    const [fProductGroups, setFProductGroups] = useState([]);
    const [productGroups, setProductGroups] = useState([]);
    const [products, setProducts] = useState([]);
    const [fProducts, setFProduct] = useState(null);
    const [fModels, setFModels] = useState([]);
    //---------------------------------------------------
    const [supportedColors, setSupportedColors] = useState([]);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedObjectColor, setSelectedObjectColor] = useState(null);
    //---------------------------------------------------
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingSelectedColor, setIsLoadingSelectedColor] = useState(false);
    //-------------- other declaration------------------
    const [defultMobile, setDefultMobile] = useState("");
    const schema = Joi.object({
        name: Joi.string().required().messages(GetMessages()),
        phoneNumber: Joi.string().min(12).required().messages(GetMessages()),
        custType: Joi.string().required().messages(GetMessages()),
        salesManID: Joi.string().required().messages(GetMessages()),
    });

    const schemaidentityNo = Joi.object({
        identityNo: Joi.string().min(10).allow('').optional().messages(GetMessages()),

    });
    const schemacn = Joi.object({
        cn: Joi.string().min(10).allow('').optional().messages(GetMessages()),
    });
    // declarations ver that using in route & searching in url
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    //------------------------------------------------------
    const [userTypeList, setUserTypeList] = useState([]);
    const [userType, setUserType] = useState("");
    const [identityType, setIdentityType] = useState(1);

    const [cnValue, setCnValue] = useState("");
    const [identityValue, setIdentityValue] = useState("");
    // ------------
    useEffect(() => {
        getAllDataVehicles();
        getAllGroups();
        getAllUserType();
        GetEmployeesSales();

        // Get the referrer information
        var ref = document.referrer;

        console.log("referrer>>>>>>>>>>>>>>>>>>>>>>>>>>:", ref);
        if (!ref) {
            ref = window.location.origin;
        }
        console.log("referrer final >>>>>>>>>>>>>>>>>>>>>>>>>>:", ref);
        setReferrer(ref);

    }, []);
    const [EmployeesSalesList, setEmployeesSalesList] = useState([]);

    const GetEmployeesSales = () => {
        axios.post(
            `${config.controllURL}${lang}/api/Pages/DetailsSite_EmployeesSales`,
            {
                "ObjectSettings": {
                    "MetaData": false
                },
                "filters": ""
            }
        ).then(response => {
            setTimeout(setEmployeesSalesList(response.data.ApiObjectData), 500);
        }).catch(err => {
            console.log(err);
        });
    };
    //----------------------
    const [selectcity, setSelectcity] = useState(null);
    const [filteredCities, setFilteredCities] = useState([]);
    useEffect(async () => {
        try {
            const settingsResponse = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/user/getSettings",
                method: "get",
            });

            if (settingsResponse.status === 200) {
                var mm = settingsResponse?.data?.genders.map(e => {
                    return { value: String(e.id), text: e.description }
                });


                setFilteredCities(settingsResponse?.data?.cities?.filter(item => {
                    return item.code == "SAU"
                }));

            }


        } catch (err) {
            console.log(err);
        }
    }, []);
    useEffect(() => {

        let result = formValidate(schema, requestForm) ?? {};

        // ex:
        // const mergedObj = Object.assign({}, obj1, obj2);
        if (identityType && identityType == 1) {
            const result22 = formValidate(schemaidentityNo, requestForm) ?? {};
            result = { ...result, ...result22 }

        } else {

            const result33 = formValidate(schemacn, requestForm) ?? {};
            result = { ...result, ...result33 }

        }
        if (Object.keys(result).length == 0) {
            setSuccessData(true);
        } else {
            setSuccessData(false);
        }
    }, [requestForm]);
    useEffect(() => {
        let data = {};

        const val = { ...requestForm };

        const productID = query.get('vehicle');
        const typeID = query.get('type');
        const model = query.get('model');
        const color = query.get('color');
        if (productID) {

            val.selectedProduct = String(productID);
            val.selectedModel = String(model);
            val.selectedColor = String(color);
            val.selectedTypeID = String(typeID);
            setproduct(val);

            setRequestForm(val);
            setShowProductSection(false);
            setType(typeID);
            handleFetchColors(typeID, model, color);
        }

        if (color)
            setSelectedColor(color);
    }, []);

    useEffect(() => {

        if (products && products.length > 0 && product && product.selectedTypeID && fProducts == null) {

            var GroupID = null;

            const filteredProducts = products.filter(e => e.productTypeID == product.selectedTypeID);

            if (filteredProducts[0])
                GroupID = filteredProducts[0].productGroupID;

            if (GroupID) {
                const filteredProductsbyGroupID = products.filter(e => e.productGroupID == GroupID && e.Model == product.selectedModel);
                setFProduct(filteredProductsbyGroupID.map(product => {
                    return { value: product.productTypeID, text: product[`${trans("model:gamelDescription")}`], ...product }
                }));

                setGroup(GroupID);
            } else {
                setFProduct([]);
            }


        }

    }, [product, products, fProducts]);
    //----------------Functions + Methods------------------------


    // It's used to filter the groups by brand
    const filterModel = (BrandID, Model) => {

        setSelectedColor(null);
        setType(null);
        setGroup(null);
        if (BrandID == '0') {
            dropDownResetter(() => {
                setFProductGroups();
                setFModels([]);
                setFProduct([]);
                setFColors([]);
            });
        }
        setBrand(BrandID);

        const fGroups = productGroups.filter(a => a.BrandID == BrandID && (a.Year == Model));
        setFProductGroups(fGroups.map(group => {
            return {
                value: group.ProductGroupID, text: group[`${trans("model:description")}`]
            }
        }));
    };


    // * siteGetCustGroupsforOrder
    const getAllUserType = () => {
        axios.post(
            `${config.controllURL}${lang}/api/Pages/siteGetCustGroupsforOrder`,
            {}
        ).then(response => {
            setUserTypeList(response.data);
        }).catch(err => {
            console.log(err);
        })
    };


    const handleCustType = (option) => {
        const val = { ...requestForm };
        val.custType = option;
        setRequestForm(val);
        console.log(userType);
        setUserType("");

        setCnValue("");
        setIdentityValue("");

        try {
            if (option == '' || option == null || option == '0') {
                setIdentityType(null);
                return;
            }

            // const currentValue = accountTypes.find(item => {
            //     return item.ID == option
            // }) ?? {};

            let value = null;
            if (option == "G4") {
                value = 1;
                val.cn = null;
                setUserType(val.cn);
            } else {
                value = 2;
                val.identityNo = null;
                setUserType(val.identityNo);
            }

            setRequestForm(val);
            setIdentityType(value);

        } catch (err) {
            //////console.log(err);
        }
    };
    // Fetch all groups
    const getAllGroups = () => {

        axios.request({
            baseURL: config.controllURL,
            url: lang + "/api/Vehicles/AvailableGroupsOnSite",
            method: "get",
        })
            .then(function (response) {
                setProductGroups(response.data);

                const uniqueGroups = Array.from(
                    new Map(response?.data?.map(item => [item.ProductGroupID, item])).values()
                );

                setProductGroups(uniqueGroups);



            })
            .catch(function (error) {
                console.log(error);
            });
    };
    //Fetch all products
    const getAllDataVehicles = async () => {

        const settingResponse = await axios.request({
            baseURL: '/',
            url: config.controllURL + lang + "/api/Maintenance/Settings",
            method: "get"
        });

        var currentSettingsbrands = settingResponse.data?.brands;
        var currentSettingsmodels = settingResponse.data?.models;
        var currentSettingsproductModels = settingResponse.data?.productModels;

        setBrands(currentSettingsbrands?.map(brand => {
            return {
                value: brand.brandID, text: brand[`${trans("model:description")}`]
            }
        }));

        setProducts(currentSettingsproductModels);
        const models = currentSettingsmodels.map(item => {
            return item.modelID
        });
        const uniqueModels = uniqBy(models, (mY) => {
            return mY;
        }).filter((value) => {
            return value !== null
        }).map(item => {
            return { text: item, value: item }
        });
        setFModels(uniqueModels);

    }

    //Filter the products by group
    const filterProductsByGroup = (option) => {
        setType(null);
        setGroup(null);
        setSelectedColor(null);
        if (option.value == '0') {
            dropDownResetter(() => {
                setFProduct([]);
                setFModels([]);
            });
        }

        setGroup(option.value);
        const val = { ...requestForm };
        val.group = String(option.value);

        const filteredProducts = products.filter(e => e.productGroupID == option.value && e.Model == requestForm.selectedModel);
        setFProduct(filteredProducts.map(product => {
            return { value: product.productTypeID, text: product[`${trans("model:gamelDescription")}`], ...product }
        }));
    };
    const handleSendRequest = async () => {

        if (isLoading == true)
            return;

        let result = formValidate(schema, requestForm) ?? {};

        console.log("formValidate result:", result);
        // ex:
        // const mergedObj = Object.assign({}, obj1, obj2);
        if (identityType && identityType == 1) {
            const result22 = formValidate(schemaidentityNo, requestForm) ?? {};
            result = { ...result, ...result22 }

        } else {

            const result33 = formValidate(schemacn, requestForm) ?? {};
            result = { ...result, ...result33 }

        }
        setError(result);

        if (Object.keys(result).length == 0) {
            if (supportedColors?.length > 0 && selectedColor == null) {
                toast.error(trans("finance:color_not_select"));
                setIsLoading(false);
                return;
            }
            setIsLoading(true);
            const basicInfo = await getMainUserData();


            const objectColor = fColors.filter(c => c.value == selectedColor)[0]
            if (!objectColor) {

            }


            var raw = {
                "Name": requestForm.name,
                "Phone": requestForm.phoneNumber,
                "Email": requestForm.email,
                "Address": requestForm.address,
                "Quantity": Number(requestForm.quantity),
                "ColorID": (selectedColor != null || selectedColor != '') ? String(selectedColor) : null,
                "ColorGroupID": objectColor ? objectColor.ColorGroupID : null,
                "BrandID": objectColor ? objectColor.BrandID : null,
                "ProductGroupID": objectColor ? objectColor.ProductGroupID : null,
                "Web_UserID": basicInfo ? Number(basicInfo.userId) : null,
                "CustID": null,
                "ProductTypeID": requestForm.selectedTypeID,
                "ModelYear": requestForm.selectedModel,
                "CustGroupID": requestForm.custType,
                "AddtionalNo": identityValue ?? cnValue ?? "",
                "Note": (requestForm?.note ?? ""),
                "ReferrerBy": (referrer ? referrer : ""),
                "SalesManID": requestForm?.salesManID ?? ""
            };

            console.log("raw>>>>>>>>>>>>>>>>:", raw);

            // return;
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            await axios.request({
                baseURL: config.controllURL,
                url: "api/Payment/AddOrderPurchaseVehicle",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            })
                .then(response => {
                    toast.success(trans("common:order-request-success"));
                    setIsLoading(false);
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000); // 2000 = 2 ثواني

                }).catch(err => {
                    toast.error(trans("finance:error_send_data"));
                    setIsLoading(false);
                });

        }
    };
    // get the main essetional info about user [web_user_id & cust_id]
    const getMainUserData = async () => {
        let data = null;
        try {
            const _data = JSON.parse(getData(User_Data_Key, true));
            if (localStorage.getItem("isAuthenticated")) {
                data = {
                    userId: Number(_data.id.toString().split('_')[1]),
                    custId: _data.custID
                };
            } else {
                const response = await axios.post(
                    `${config.controllURL}${lang}/api/Pages/Detailsweb_users`,
                    {
                        "Option": "Column",
                        "ObjectSettings": {
                            "MetaData": false,
                            "Limit": {
                                "Value": 1,
                                "Optional": "Top"
                            }
                        },
                        "Fields": "Web_UserId,CustID",
                        "Filters": `where lower(email) = lower('${requestForm.email}')`
                    }
                );
                if (response.status == 200) {
                    const result = response.data.ApiObjectData;
                    if (result.length > 0) {
                        const finalResult = result[0];
                        data = {
                            userId: finalResult.Web_UserId,
                            custId: finalResult.CustID
                        };
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
        return data;
    };
    const handleFetchColors = (productTypeID, modelYear, defultColor) => {
        setFColors([]);
        if (productTypeID != '' && modelYear != '') {

            setIsLoadingSelectedColor(true);
            axios.post(
                `${config.controllURL}${lang}/api/Pages/site_fetchColorOfType`,
                {
                    "Type": productTypeID,
                    "model": modelYear
                }
            ).then(response => {


                const uniquefilterColors = Array.from(
                    new Map(response?.data?.map(item => [item.ColorID, item])).values()
                );

                const filterColors = uniquefilterColors?.map((item) => {
                    return {
                        text: (lang == "ar" ? item?.ColorDescriptionAr : item?.ColorDescriptionEn),
                        value: item.ColorID, ...item
                    }
                });
                setFColors(filterColors);
                setIsLoadingSelectedColor(false);
                if (defultColor) {
                    setSelectedColor(defultColor);
                } else {

                    if (filterColors && filterColors[0]) {
                        setSelectedColor(filterColors[0].value);
                    }
                }

            }).catch(error => {
                setIsLoadingSelectedColor(false);
                console.log(error);
            })


        }
    };


    return (
        <Fragment>


            <div className="container">
                <Breadcrumb className={"mt-16 "}
                    links={[
                        {
                            name: trans("finance:veh-order"),
                        },
                    ]}
                />
            </div>

            <div className="container mb-32 mt-32 ">

                <div className={"grid-2-cols  gap-5 mb-40"}>
                    <div className={"inputs-group gap-4 flex-grow-1"}>
                        <InputField
                            extraClasses={"Input-module"}
                            moduleLabel={trans("form:name")}
                            placeholder={""}
                            value={requestForm.name}
                            errorLabel={error?.name}

                            onChangeValue={(e) => {
                                const val = { ...requestForm };
                                val.name = e.target.value;
                                setRequestForm(val);
                            }}

                            name='name'
                        />
                        <DropDownInput
                            title={trans("new:city")}
                            errorLabel={error.address}
                            extraClasses={"dropdown-Input-module"}
                            selectedValue={requestForm.City}
                            options={[...filteredCities?.map(item => {
                                return { text: item?.description, value: item?.id, optional: item?.code }
                            })]}
                            onfilter={(Citey) => {
                                const val = { ...requestForm };
                                val.City = Citey.value;
                                val.address = Citey.text;
                                setRequestForm(val);

                            }}
                        />
                        <PhoneDropDown
                            placeholder={trans("form:phone")}
                            moduleLabel={trans("form:phone")}
                            extraClasses={"phone-Input-module"}
                            errorLabel={error?.phoneNumber}
                            defaultValue={defultMobile}
                            onChangeValue={
                                (key, value) => {
                                    const val = { ...requestForm };
                                    val.phoneNumber = `+${key}${value}`;
                                    setRequestForm(val);
                                }
                            }
                        />
                        <InputField
                            value={requestForm.email}
                            extraClasses={"Input-module"}
                            moduleLabel={trans("form:email")}
                            placeholder={""}
                            type='email'
                            onChangeValue={(e) => {
                                const val = { ...requestForm };
                                val.email = e.target.value;
                                setRequestForm(val);
                            }}
                            errorLabel={error?.email}
                            name='email'
                        />


                        <TextArea
                            placeholder={""}
                            moduleLabel={trans("finance:note")}
                            extraClasses={"Textarea-module"}
                            value={requestForm?.note}
                            onChangeValue={
                                (e) => {
                                    const val = { ...requestForm };
                                    val.note = e;
                                    setRequestForm(val);
                                }
                            }
                            name='note'

                            row={3}

                        />

                    </div>
                    <div className={"inputs-group gap-4 flex-grow-1"}>

                        {
                            // 
                            <div className={`grid ${requestForm?.custType == null ? 'grid-cols-1 ' : 'grid-cols-3'} gap-2 gap-y-16 `}>

                                <DropDownInput roundedFull={"rounded-full"}
                                    extraClasses={"dropdown-Input-module col-span-12 lg:col-span-1 mt-5"}
                                    title={trans("finance:applicant")}
                                    defaultOption={
                                        (requestForm?.custType == null || requestForm?.custType == "")
                                            ? { text: trans("finance:applicant"), value: '0' }
                                            : null}
                                    errorLabel={error?.custType}
                                    options={[...userTypeList.map(item => {
                                        return { text: lang == "ar" ? item.DescriptionAr : item.DescriptionEn, value: item.ID }
                                    })]}
                                    onSelect={handleCustType}

                                    selectedValue={requestForm.custType}
                                />

                                {
                                    (requestForm?.custType == null)
                                        ? <></>
                                        : <div className="col-span-12 lg:col-span-2 mt-5">
                                            <InputField
                                                extraClasses={"Input-module"}
                                                moduleLabel={(identityType && identityType == 1)
                                                    ? trans("form:identity-no")
                                                    : (identityType === 2) ? trans("finance:cn") : trans("form:identity-no")}
                                                placeholder={""}
                                                errorLabel={(identityType && identityType == 1)
                                                    ? error?.identityNo
                                                    : (identityType == 2) ? error?.cn : error?.identityNo
                                                }

                                                value={(identityType && identityType == 1)
                                                    ? identityValue
                                                    : (identityType == 2) ? cnValue : identityValue
                                                }

                                                length={10}
                                                onChangeValue={(e) => {
                                                    const val = { ...requestForm };
                                                    if (identityType && identityType == 1) {

                                                        val.identityNo = e.target.value;
                                                        setIdentityValue(e.target.value);

                                                    } else {

                                                        val.cn = e.target.value;
                                                        setCnValue(e.target.value);
                                                    }
                                                    setRequestForm(val);
                                                }}

                                                onLeave={(e) => {
                                                    console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeee", e);
                                                }}
                                            />
                                        </div>
                                }

                            </div>
                            //
                        }


                        <DropDownInput
                            extraClasses={"dropdown-Input-module"}
                            title={trans("info:company")}
                            defaultOption={(brand == '0' || brand == null) ? {
                                text: trans("info:company"),
                                value: '0'
                            } : null}
                            onfilter={(option) => filterModel(option.value, requestForm.selectedModel)}
                            options={[...brands]}
                            selectedValue={brand}
                        />
                        <DropDownInput
                            title={trans("info:created_year")}
                            extraClasses={"dropdown-Input-module"}
                            selectedValue={year}
                            errorLabel={error?.selectedModel}

                            defaultOption={{
                                text: trans("info:created_year"),
                                value: '0'
                            }}
                            options={[...fModels]}
                            onSelect={
                                (e) => {
                                    const val = { ...requestForm };
                                    val.selectedModel = String(e);
                                    setYear(e);
                                    setRequestForm(val);
                                    setSelectedColor(null);
                                    filterModel(brand, e);
                                }
                            }
                        />
                        <DropDownInput
                            title={trans("eparts:vehicle")}
                            selectedValue={group}
                            extraClasses={"dropdown-Input-module"}
                            defaultOption={((brand == '0' || brand == null) || (group == '0' || group == null)) ? {
                                text: trans("eparts:vehicle"),
                                value: '0'
                            } : null}
                            options={[...fProductGroups]}
                            onfilter={filterProductsByGroup}
                        />



                        <DropDownInput
                            selectedValue={type}
                            title={trans("eparts:model")}
                            extraClasses={"dropdown-Input-module"}
                            errorLabel={error?.selectedTypeID}
                            defaultOption={((brand == '0' || brand == null) || (group == '0' || group == null)) ? {
                                text: trans("eparts:model"),
                                value: '0'
                            } : null}
                            options={fProducts ? [...fProducts] : []}
                            onfilter={
                                (e) => {

                                    if (e.value == '0') {
                                        dropDownResetter(() => {
                                            setFModels([]);
                                            setFColors([]);
                                        });
                                        return;
                                    }
                                    const val = { ...requestForm };
                                    val.selectedTypeID = String(e.value);
                                    setType(val.selectedTypeID);
                                    setRequestForm(val);

                                    setSelectedColor(null);
                                    // handleShowVehicleDetails(e.productID, val.selectedModel);
                                    handleFetchColors(e.productTypeID, val.selectedModel);
                                }
                            }
                        />



                        <DropDownInput
                            title={trans("info:avaliable_colors")}
                            extraClasses={"dropdown-Input-module"}
                            selectedValue={selectedColor}
                            defaultOption={{
                                text: trans("info:avaliable_colors"),
                                value: '0'
                            }}
                            isLoading={isLoadingSelectedColor}
                            onSelect={(option) => {
                                setSelectedColor(option);
                                // setOuterCarImagesJson(null);
                                console.log("fColors:", fColors);
                                console.log("option:", option);
                                const objectColor = fColors.filter(c => c.value == option)[0]?.ProductID;
                                console.log("objectColor:", objectColor);
                            }}
                            options={[...fColors]}
                        />

                        <InputField
                            extraClasses={"Input-module"}
                            moduleLabel={trans("finance:quantity")}
                            placeholder={""}
                            value={requestForm?.quantity}
                            type='number'
                            onChangeValue={(e) => {
                                const val = { ...requestForm };
                                val.quantity = e.target.value;
                                setRequestForm(val);
                            }}
                            errorLabel={error?.quantity}
                            name='quantity'
                        />
                        <DropDownInput
                            title={":استشاري المبيعات"}
                            extraClasses={"dropdown-Input-module"}
                            selectedValue={requestForm?.salesManID}
                            errorLabel={error?.salesManID}

                            defaultOption={{
                                text: "يجب تحديد استشاري  المبيعات",
                                value: '0'
                            }}

                            options={[...EmployeesSalesList.map(item => {
                                return { text: lang == "ar" ? item.FullNameAr : item.FullNameEn, value: item.EmpID }
                            })]}
                            onSelect={
                                (e) => {
                                    const val = { ...requestForm };
                                    val.salesManID = String(e);
                                    setRequestForm(val);
                                }
                            }
                        />


                    </div>
                </div>

                <FormButton
                    isLoading={isLoading}
                    name={trans("form:send-order")}
                    isPrimary={successData}
                    classes={" px-10 py-5 text-24  w-sm-100 text-bold"}
                    onClick={async () => {
                        if (isLoading == false)
                            await handleSendRequest();
                    }}
                />
            </div>
        </Fragment>
    );
}